import { render, staticRenderFns } from "./heat.vue?vue&type=template&id=edff1af4&scoped=true"
import script from "./heat.vue?vue&type=script&lang=js"
export * from "./heat.vue?vue&type=script&lang=js"
import style0 from "./heat.vue?vue&type=style&index=0&id=edff1af4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edff1af4",
  null
  
)

export default component.exports